import { useTenantStore } from '@/stores/tenantStore'
import { $api, type InferResponse } from '../../typedClient'

export type OrderEmailsResponse = InferResponse<
  '/crossroads/order/get_email_logs',
  'post'
>
export type OrderEmail = OrderEmailsResponse[number]

export function useOrderEmails(orderId: string | null | undefined) {
  const { selectedTenant } = useTenantStore()
  const shouldFetch = !!orderId && !!selectedTenant?.name

  return $api.useQuery(
    'post',
    '/crossroads/order/get_email_logs',
    {
      params: { query: { order_id: orderId ?? '' } },
    },
    {
      enabled: shouldFetch,
    },
  )
}
